import PathCard from './v2'

export default PathCard
